/**
 * Componente para la edición de la cantidad del ciclo de curva
 */
import React, { useState } from "react";
import axios from "axios";
import { API_URL } from "../../../utils/Common";

const CantidadCicloCurva = (props) => {
   const { cantidad, cicloId, campo } = props;

   const [valor, setValor] = useState(cantidad);

   const handleChange = (e) => {
      setValor(e.target.value);
      axios.post(API_URL + "/updateCiclo", { cantidad: e.target.value, campo, cicloId });
   };

   return (
      <input
         className="mt-0 text-xs text-right appearance-none block w-16 bg-orange-200 text-gray-700 border border-orange-200 rounded py-2 px-1 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
         type="number"
         step="any"
         value={valor}
         name="cantidad"
         onChange={handleChange}
      />
   );
};

export default CantidadCicloCurva;
